import { cn } from '@/lib/utils';

export interface OptionChip<OptionValue> {
  value: OptionValue;
  label: string;
}

interface OptionChipsProps<OptionValue> {
  label: string;
  options: OptionChip<OptionValue>[];
  selectedValue: OptionValue;
  onSelect: (nextValue: OptionValue) => void;
  isLabelHidden?: boolean;
}

export function OptionChips<OptionValue>({
  label,
  options,
  selectedValue,
  onSelect,
  isLabelHidden = false,
}: OptionChipsProps<OptionValue>) {
  return (
    <div role="radiogroup" aria-label={label}>
      <p
        className={cn(
          'text-xs font-bold text-zoomuted tracking-wider uppercase mb-2',
          isLabelHidden === true ? 'sr-only' : ''
        )}
      >
        {label}
      </p>
      <div className="flex flex-wrap gap-2">
        {options.map(function renderOption(option) {
          const isSelected = option.value === selectedValue;
          return (
            <button
              key={option.label}
              type="button"
              role="radio"
              aria-checked={isSelected}
              onClick={function select() {
                onSelect(option.value);
              }}
              className={cn(
                'px-3.5 py-2 rounded-xl text-sm font-medium border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-zooprimary',
                isSelected
                  ? 'bg-zooprimary border-zooprimary text-zoowhite shadow-sm'
                  : 'bg-zoowhite border-zooborder text-zoomuted hover:border-zooprimary hover:text-zooprimary'
              )}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
